import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const nav = useNavigate();
    const { refresh } = useAuth();
    const hasProcessed = React.useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) { nav("/"); return; }
        const session_id = match[1];

        (async () => {
            try {
                await api.post("/auth/session", { session_id });
                await refresh();
                nav("/dashboard", { replace: true });
            } catch (e) {
                nav("/?auth_error=1", { replace: true });
            }
        })();
    }, [nav, refresh]);

    return (
        <div className="min-h-[70vh] flex items-center justify-center">
            <div className="text-center">
                <div className="mx-auto h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
                <p className="mt-4 text-muted-foreground">Signing you in…</p>
            </div>
        </div>
    );
}
